import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./buildInfo"; // Build timestamp for deployment verification

// For production (lightstreamengineering.com), use same-origin API
// This avoids CORS issues by calling the backend on the same domain
if (window.location.hostname === 'lightstreamengineering.com' || 
    window.location.hostname === 'www.lightstreamengineering.com') {
  // Use same-origin for production - no cross-origin issues
  window.__RUNTIME_BACKEND_URL__ = window.location.origin;
  console.log('🔧 Production mode - using same-origin API:', window.__RUNTIME_BACKEND_URL__);
}

// Deep link from welcome emails: ?tutorial=<slug> opens that video after login
const _tutorialSlug = new URLSearchParams(window.location.search).get('tutorial');
if (_tutorialSlug) sessionStorage.setItem('openTutorial', _tutorialSlug);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
